import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Box } from '@mui/material';
import * as usersActions from '../../../actions/users';
import * as authActions from '../../../actions/auth';
import UsersTableNew from '../../../components/UsersTableNew';
import FABContext from '../../../context/FABContext/FABContext';
import { setFABActions } from '../../../helpers/fab';

class UserSelector extends Component {
  componentDidMount() {
    const { fetchUsers } = this.props;

    fetchUsers();
  }

  render() {
    const { users, impersonateUser, history } = this.props;

    return (
      <Box sx={{ height: 320 }}>
        <UsersTableNew
          isLoading={users.inflight}
          data={Object.values(users.byId)}
          onRowClick={userId => {
            impersonateUser(userId);
            setFABActions(users.byId[userId], history, this.context);
          }}
        />
      </Box>
    );
  }
}

const mapStateToProps = ({ entities: { users } }) => ({
  users,
});
const mapDispatchToProps = dispatch => ({
  fetchUsers: () => dispatch(usersActions.fetchUsersIfNeeded()),
  impersonateUser: userId => dispatch(authActions.changeUser(userId)),
});

UserSelector.contextType = FABContext;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserSelector));
